(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["redirect-home"] && !Shopify.designMode) return;
  try {
    
  const root = document.querySelector('[data-headless-origin]');

  if (root) {
    const origin = root.dataset.headlessOrigin;
    const fallbackUrl = root.dataset.fallbackUrl;
    const path = window.location.pathname === '/account/email_marketing_unsubscribe'
      ? '/account/unsubscribe'
      : window.location.pathname;
    const target = new URL(path + window.location.search + window.location.hash, origin);

    if (window.location.hostname !== target.hostname) {
      window.location.replace(target.toString());
    } else if (fallbackUrl) {
      const link = root.querySelector('.cosmic-redirect__button');
      if (link) {
        link.setAttribute('href', fallbackUrl);
      }
    }
  }

  } catch(e) { console.error(e); }
})();
})();
